var map = {
	"./buyalskaya-aleksandra-vladimirovna.png": 6610,
	"./cheremnykh.png": 18,
	"./closeDoctor.svg": 2200,
	"./doctor-no-img.png": 589,
	"./doctor1.png": 3950,
	"./edinova-mariya-valerievna.png": 8645,
	"./filter.svg": 1307,
	"./filterWhite.svg": 3631,
	"./golubeva.png": 2297,
	"./hakimova.png": 2675,
	"./kindyalova.png": 2975,
	"./ledyaeva.png": 1555,
	"./orlov-sergej-vladimirovich-4-1.png": 5505,
	"./rykova-aleksandra-yurevna.png": 9873,
	"./sviridenko.png": 8707,
	"./urtenova.png": 2040,
	"./x-10329.svg": 207,
	"./yanchiy.png": 2588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2023;